import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Paper, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { authenticationActionCreators } from "../../actions/authentication/AuthenticationActionCreators";
import StudentBaseForm from "./forms/StudentBaseForm";
import StudentDetailsForm from "./forms/StudentDetailsForm";
import { withTranslation } from "react-i18next"; // Import withTranslation

const styles = (theme) => ({
    appBar: {
        position: "relative",
    },
    layout: {
        width: "auto",
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            width: 600,
            marginLeft: 435,
            marginRight: "auto",
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    stepper: {
        padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end",
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
    },
});

class StudentRegistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
        };

        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    nextPage() {
        this.setState({ page: this.state.page + 1 });
    }

    previousPage() {
        this.setState({ page: this.state.page - 1 });
    }

    handleSubmit() {
        this.props.registerStudent();
    }

    render() {
        const { classes, t } = this.props; // Destructure t from props
        const { page } = this.state;

        return (
            <React.Fragment>
                <main className={classes.layout}>
                    <Paper className={classes.paper}>
                        <Typography variant="h4" align="center">
                            {t("studentRegistrationTitle")} {/* Translate "Регистрация студент" */}
                        </Typography>
                        {page === 1 && <StudentBaseForm onSubmit={this.nextPage} />}
                        {page === 2 && (
                            <StudentDetailsForm
                                previousPage={this.previousPage}
                                onSubmit={this.handleSubmit}
                            />
                        )}
                    </Paper>
                </main>
            </React.Fragment>
        );
    }
}

//StudentRegistration.propTypes = {
//    classes: PropTypes.object.isRequired,
//    t: PropTypes.func.isRequired, // Add t to propTypes
//};

export default withStyles(styles)(
    withTranslation()( // Wrap the component with withTranslation
        connect(
            (state) => state.authentication,
            (dispatch) => bindActionCreators(authenticationActionCreators, dispatch)
        )(StudentRegistration)
    )
);

//import React, { Component } from 'react';
//import withStyles from '@material-ui/core/styles/withStyles';
//import { Paper, Typography } from '@material-ui/core';
//import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { authenticationActionCreators } from '../../actions/authentication/AuthenticationActionCreators';
//import StudentBaseForm from './forms/StudentBaseForm';
//import StudentDetailsForm from './forms/StudentDetailsForm';

//const styles = theme => ({
//    appBar: {
//        position: 'relative',
//    },
//    layout: {
//        width: 'auto',
//        marginLeft: theme.spacing.unit * 2,
//        marginRight: theme.spacing.unit * 2,
//        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
//            width: 600,
//            marginLeft: 435,
//            marginRight: 'auto',
//        },
//    },
//    paper: {
//        marginTop: theme.spacing.unit * 3,
//        marginBottom: theme.spacing.unit * 3,
//        padding: theme.spacing.unit * 2,
//        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
//            marginTop: theme.spacing.unit * 6,
//            marginBottom: theme.spacing.unit * 6,
//            padding: theme.spacing.unit * 3,
//        },
//    },
//    stepper: {
//        padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
//    },
//    buttons: {
//        display: 'flex',
//        justifyContent: 'flex-end',
//    },
//    button: {
//        marginTop: theme.spacing.unit * 3,
//        marginLeft: theme.spacing.unit,
//    },
//});

//class StudentRegistration extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//            page: 1
//        };

//        this.nextPage = this.nextPage.bind(this);
//        this.previousPage = this.previousPage.bind(this);
//        this.handleSubmit = this.handleSubmit.bind(this);
//    }

//    nextPage() {        
//        this.setState({ page: this.state.page + 1 })
//    }

//    previousPage() {
//        this.setState({ page: this.state.page - 1 })
//    }

//    handleSubmit() {
//        this.props.registerStudent();
//    }

//    render() {
//        const { classes } = this.props;
//        const { page } = this.state;

//        return (
//            <React.Fragment>
//                <main className={classes.layout}>
//                    <Paper className={classes.paper}>
//                        <Typography variant="h4" align="center">
//                            Регистрация студент
//                        </Typography>
//                        {page === 1 && <StudentBaseForm onSubmit={this.nextPage} />}
//                        {page === 2 && <StudentDetailsForm previousPage={this.previousPage} onSubmit={this.handleSubmit} />}                        
//                    </Paper>
//                </main>
//            </React.Fragment>
//        );
//    }
//}

//export default withStyles(styles)(connect(
//    state => state.authentication,
//    dispatch => bindActionCreators(authenticationActionCreators, dispatch)
//)(StudentRegistration));